import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import {
  COLOR_AGENCY_STATUS,
  COLOR_POPUP_STATUS,
  LIST_CHANNEL_OPTION,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  POPUP_DISPLAY_SCREEN_OPTION,
  POPUP_STATUS_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import moment from "moment";
import CopyWrapper from "components/Common/CopyWrapper";
import { getAgencyList } from "store/agency/thunk";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import NO_IMAGE from "../../assets/images/no-job-post.png";
import ICLINK from "../../assets/images/icons/ic_link.svg";
import ICCalendar from "../../assets/images/icons/ic_calendar.svg";
import { getPopupList } from "store/popup/thunk";
import popupApi from "api/popupApi";
import PopupManagerForm from "./PopupManagerForm";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import { stat } from "fs";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const PopupManagerPro = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    url: withDefault(StringParam, ""),
    section: withDefault(StringParam, ""),
    isActive: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "createdAt"),
    // orderBy: withDefault(StringParam, "desc"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);

  const [urlSearch, setURLSearch] = useState<string>(
    query?.url || ""
  );
  const [sectionSearchSearch, setSectionSearch] = useState<Option | any>(
    POPUP_DISPLAY_SCREEN_OPTION?.find(
      (item) => item?.value === query?.section
    )?.value || ""
  );
  const [isActiveSearch, setIsActiveSearch] = useState<Option | any>(
    POPUP_STATUS_OPTION?.find((item) => item?.value == query?.isActive)
      ?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Popup;
  const PopupProperties = createSelector(selectLayoutState, (state) => ({
    lstPopup: state.lstPopup,
    isAgencyLoading: state.isPopupLoading,
    isAgencySuccess: state.isPopupSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstPopup, isAgencyLoading } = useSelector(PopupProperties);

  function loadTableData() {
    dispatch(getPopupList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      url: urlSearch,
      section: sectionSearchSearch,
      isActive: isActiveSearch === 1 ? true : isActiveSearch === 0 ? false : "",
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        url: "",
        section: "",
        isActive: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setURLSearch((_prev) => "");
    setSectionSearch((_prev: any) => "");
    setIsActiveSearch((_prev: any) => "");
  };

  const handleOnConfirmUpdate = async (item: any) => {
    if (!item?.id) return;

    try {
      const response: any = await popupApi.updatePopup(item?.id, {
        ...item,
        isActive: item?.isActive,
      });

      if (response?.code === 200) {
        dispatch(getPopupList(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {lstPopup?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "isActive",
        thWidth: 80,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="isActive"
                checked={cell?.value}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    ...item,
                    isActive: value,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Content"),
        accessor: "imageUrl",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const photo = cell?.value ?? NO_IMAGE;
          const item: any = cell?.row?.original;

          return (
            <>
              <div className="d-flex gap-2">
                <div
                  className="cursor-pointer"
                  onClick={() => setLinkImage({ url: photo })}
                  style={{ width: "100px", height: "80px", minWidth: "100px" }}
                >
                  <img
                    src={photo}
                    className="w-100 h-full object-fit-cover rounded"
                    style={{ maxHeight: "80px" }}
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = NO_IMAGE;
                    }}
                  />
                </div>
                <div>
                  <div>
                    <span
                      style={{
                        backgroundColor: item?.isActive
                          ? "#d1fae5"
                          : "#f1f5f9",
                        color: item?.isActive ? "#047857" : "#64748b",
                        padding: "2px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {POPUP_STATUS_OPTION.find(
                        (opt) => opt.value == item?.isActive
                      )?.label || item?.isActive}
                    </span>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      src={ICLINK}
                      alt="icon link"
                      width={12}
                      height={12}
                    />
                    <CopyWrapper
                      contentCopy={item?.url}
                    >
                      {item?.url || "-"}
                    </CopyWrapper>
                  </div>
                  <small className="text-secondary d-flex gap-2 align-items-center">
                    <img
                      src={ICCalendar}
                      alt="icon link"
                      width={12}
                      height={12}
                    />
                    <div>
                      {formatDateStringToKorea(item?.startDate, "YYYY-MM-DD")} ~ {" "}
                      {formatDateStringToKorea(item?.endDate, "YYYY-MM-DD")}
                    </div>
                  </small>
                  <div>
                    {
                      item?.show_sections?.map((screen: string, index: number) => (
                        <span
                          key={index}
                          className="badge bg-info me-1"
                        >
                          {/* {screen} */}
                          {t(POPUP_DISPLAY_SCREEN_OPTION.find(opt => opt.value === screen)?.label || screen)}
                        </span>
                      ))
                    }
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updatedAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstPopup?.meta?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await popupApi?.deletePopup(id);
      if (response?.code === 200 && response?.message === "Success") {
        setItemToDelete(false);
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        toast(
          `${t("The agency has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Popup Management")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Popup Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={lstPopup?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-7 con-sm-6 text-end">
                      <div className="col-sm-auto">
                        <div>
                          <button
                            type="button"
                            className="btn btn-success add-btn"
                            onClick={() => {
                              setIsOpen(true);
                              setItemToEdit(null);
                            }}
                          >
                            <i className="ri-add-line align-bottom me-1"></i>
                            {t("Button Create Popup")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("URL Search")}
                          isShow={!!urlSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("URL Search")}...`}
                            value={urlSearch}
                            onChange={(e) => setURLSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Display Screen")} isShow={true}>
                          <DropdownOptionNew
                            name="displayScreen"
                            dataList={POPUP_DISPLAY_SCREEN_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sectionSearchSearch}
                            onChangeSelect={(e: any) =>
                              setSectionSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Display Status")} isShow={true}>
                          <DropdownStatusNew
                            name="isActive"
                            dataList={POPUP_STATUS_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isActiveSearch}
                            onChangeSelect={(e: any) =>
                              setIsActiveSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_POPUP_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-3 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-recruiter-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={lstPopup?.list?.length ? lstPopup?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={lstPopup?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(lstPopup?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isAgencyLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <PopupManagerForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Popup Information")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {previewQRCode && (
          <ModalPreviewQRCode
            itemQRCode={previewQRCode}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default PopupManagerPro;
